import { render, staticRenderFns } from "./CSCustomerHistory.vue?vue&type=template&id=5dbd452e&lang=pug&"
import script from "./CSCustomerHistory.vue?vue&type=script&lang=js&"
export * from "./CSCustomerHistory.vue?vue&type=script&lang=js&"
import style0 from "./CSCustomerHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports